<template>
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="$emit('closeModal')">
          <div class="row">
            <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
            <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
              <div class="modal-container" @click.stop>
  
                <div class="modal-header row" style="justify-content: flex-end;">
                  <!-- <div class="col-6">
                    <button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
                  </div> -->
                  <div class="col">
                    <button type="button" class="close" @click="$emit('closeModal')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
  
                <div class="modal-body">
                  <h2 class="title">Riwayat Pembayaran {{laborer.name}}</h2>
                  <h4 class="text-center">Tanggal: {{dateLabel}}</h4>

                  <div class="text-center w-100">
                    <div class="btn-group" role="group">
                      <button
                        v-for="mon in options.period"
                        type="button"
                        class="btn"
                        :class="buttonChosen == mon ? 'btn-secondary' : 'btn-outline-secondary'"
                        @click="buttonChosen = mon"
                      >{{mon}} Month</button>
                    </div>
                  </div>

                  <div class="mt-5" style="display:block;overflow-x:auto">
                    <table class="table text-center">
                      <thead class="thead-dark">
                        <th>Tanggal</th>
                        <th>Nama Pekerja</th>
                        <th>Role Pekerja</th>
                        <th>Gaji</th>
                        <th>Index Prestasi Kerja</th>
                        <th>Bonus KPI</th>
                        <th>Full Attendance</th>
                        <th>Bonus Attendance</th>
                        <th>Total Bayar</th>
                      </thead>
                      <tbody v-if="data" v-for="(dat, index) in data" :key="index">
                        <tr>
                          <td>{{dat.work_week_date}}</td>
                          <td>{{dat.laborer}}</td>
                          <td>{{dat.role}}</td>
                          <td>Rp. {{numberWithCommas(dat.wage)}}</td>
                          <td>{{dat.kpi}}</td>
                          <td>Rp. {{numberWithCommas(dat.bonusKpi)}}</td>
                          <td>{{dat.attendance==6?'Y':'N'}} ({{dat.attendance}}/6 Days)</td>
                          <td>Rp. {{numberWithCommas(dat.bonusAttendance)}}</td>
                          <td>Rp. {{numberWithCommas(dat.total)}}</td>
                        </tr>
                      </tbody>
                      
                    </table>
                  </div>

                </div>
            </div>
          </div>
        </div>
        <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
      </div>
    </div>
  </transition>
  </template>
  
  <script>
    import moment from 'moment';
    import qs from 'qs';
    import MultiSelect from 'vue-multiselect';
  
    export default {
      data () {
        return {
          laborer : this.$store.getters.getLaborerById(this.laborer_id),
          filter : {
            labourers : this.laborer_id,
            start : moment().subtract(1, 'months').format('YYYY-MM-DD'),
            end : moment().format('YYYY-MM-DD'),
          },
          options : {
            period : [1, 3, 6],
          },
          buttonChosen : 1,
          data : null,
        }
      },
      props : ['laborer_id'],
      components:{
        MultiSelect,
      },
      mounted () {
        this.fetchData();
      },
      watch : {
        buttonChosen () {
          this.filter.start = moment().subtract(this.buttonChosen, 'months').format('YYYY-MM-DD');
          this.fetchData();
        },
      },
      computed : {
        dateLabel () {
          return `${moment(this.filter.start).format('MMM D YYYY')} sampai ${moment(this.filter.end).format('MMM D YYYY')}`
        },
      },
      methods : {
        fetchData () {
          this.$http.get(`/api/v1/paycheck${qs.stringify(this.filter, {skipNulls:true, addQueryPrefix:true})}`)
          .then((resp)=>{
            let data = resp.data.data;
            let filteredData = [];
            
            for (var i in data) {
              let laborer = this.$store.getters.getLaborerById(data[i].labourer_id)
              filteredData.push({
                laborer_id : data[i].labourer_id,
                work_week_date : moment(data[i].work_week_date).format('D MMM YYYY'),
                laborer : laborer.name,
                role : laborer.labour_type[0].labourer.name,
                wage : data[i].base_salary,
                kpi : data[i].kpi_index,
                bonusKpi : data[i].kpi_bonus,
                attendance : data[i].attendance_count ? data[i].attendance_count : 0,
                bonusAttendance : data[i].attendance_bonus,
                total : data[i].base_salary + data[i].kpi_bonus + data[i].attendance_bonus,
              })
            }

            this.data = filteredData;
          })
          .catch((err)=>{console.log(err)})
        },
      }
    }
  </script>
  
  <style scoped>
      
  </style>
  